'use client';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import CaseStudySingle from '@/components/common/ui/single-item/CaseStudySingle';
import Masonry from 'react-layout-masonry';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import { StyledStroriesList } from '@/components/common/ygen/sections/stories-list/stories-list.style';
import styled from 'styled-components';

const StyledBlogList = styled(StyledStroriesList)`
	.case-study-single .global-image-image .global-image {
		aspect-ratio: 4 / 3;
	}
	.case-study-single .global-image-image img {
		position: absolute !important;
		height: 100% !important;
		object-fit: cover;
	}
`;

// The existing masonry package reads window during render. Keep cards in the
// server HTML, then enable its layout after hydration.
const BlogMasonry = ({ children, columns, gap, className }) => {
	const [mounted, setMounted] = useState(false);
	useEffect(() => setMounted(true), []);
	if (mounted) return <Masonry columns={columns} gap={gap} className={className}>{children}</Masonry>;
	const cards = React.Children.toArray(children);
	return (
		<div className={className} style={{ display: 'flex', gap }}>
			{Array.from({ length: columns }, (_, column) => (
				<div key={column} style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap }}>
					{cards.filter((_, index) => index % columns === column)}
				</div>
			))}
		</div>
	);
};

const BlogList = ({ articles = [], error = false }) => {
	const isMobile = useDeviceTypeMobile();
	const items = Array.isArray(articles) ? articles.filter(item => item?.data?.status === 1) : [];

	return (
		<StyledBlogList className="JobList" data-scroll-section>
			<Container>
				{items.length > 0 ? (
					<BlogMasonry columns={isMobile ? 2 : 4} gap={isMobile ? 15 : 30} className="row masonary-row">
						{items.map(item => {
							const article = item.data;
							const thumb = Array.isArray(item.images) ? item.images.find(image => image?.thumb === 'on') : undefined;
							return (
								<div className="show fade-up" key={article.slug}>
									<CaseStudySingle
										hover="#DD223F"
										hoverText="Read Article"
										noPara
										link={'/blog/' + article.slug}
										subColor="rgba(21,38,55,0.5)"
										color="#152637"
										img={thumb?.full_path}
										title={article.title || ''}
										subject={article.date || ''}
										description={article.subtitle || ''}
									/>
								</div>
							);
						})}
					</BlogMasonry>
				) : (
					<p role="status">{error ? 'Blog articles are temporarily unavailable. Please try again later.' : 'No Blog articles are available yet.'}</p>
				)}
			</Container>
		</StyledBlogList>
	);
};

export default React.memo(BlogList);
